import { render, staticRenderFns } from "./FormQuizzBasicInfo.vue?vue&type=template&id=a340ca66&scoped=true&"
import script from "./FormQuizzBasicInfo.vue?vue&type=script&lang=js&"
export * from "./FormQuizzBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormQuizzBasicInfo.vue?vue&type=style&index=0&id=a340ca66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a340ca66",
  null
  
)

export default component.exports